import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaArchive } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

function SoftDeleteButton({ handler, label }: { handler: () => void, label: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={(
        <Tooltip id="soft-delete-button-tooltip">
          {t('Soft_Delete_Action_Description')}
        </Tooltip>
      )}
    >
      <Button variant="link" className="linkactions" onClick={handler}>
        <FaArchive />
        {label && (<span>{label}</span>)}
      </Button>
    </OverlayTrigger>
  );
}

export default SoftDeleteButton;
